import actions from '@/store/modules/registration/actions';
import mutations from '@/store/modules/registration/mutations';

const state = {
  emailConfirmation: {
    loading: true,
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
